
import React, {useState, useEffect} from 'react';

import { useStateValue } from './state';

import {getTableMetadata, listTables} from './data';

export const TablesMenu = () => {

    const [tables, setTables] = useState([]);

    const [{connection}, dispatch] = useStateValue();

    if(!connection) {
        // dispatch({type: 'connect', target:'localhost:8000'});
        dispatch({type: 'connect', target:'CMH'});

    }

    useEffect( () => {

        const fetchData = async () => {

            const data = await listTables(connection );
            if(Array.isArray(data)) {

                setTables(data);

                // dispatch({type: 'appendLog', newMsg: 'listTables()'});

            } else {

                dispatch({type: 'appendLog', newMsg: 'error: ' + data});
            }

        };

        if(connection) {

            setTables([]);
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connection]);

    return (
        <TablesRenderer tables={tables} />
    );

};


const TablesRenderer =  (props) => {

    const [{connection}, dispatch] = useStateValue();

    const [{metadata}, ] = useStateValue();

    const [{operation}, ] = useStateValue();

    if(operation.target && (metadata.length === 0 || metadata.Table.TableName !== operation.target)) {

        const fetchData = async () => {
            const data = await getTableMetadata(connection, operation.target);

            dispatch({type: 'setMetadata', metadata: data});

        };

        fetchData();

    }


    return (
        <>
        <table  >
            <tbody>
            <tr><td>Your tables:</td></tr>

                {props.tables.map(
                    (t, index) => (

                        <tr key={index}>
                            <td className='Nav'>

                                <button
                                    className={operation.target === t ? 'btnSelected':'btnDefault' }
                                    onClick={
                                    () => {

                                        // dispatch({type: 'clearLog'});

                                        dispatch({type: 'appendLog', newMsg: t + ': describeTable()'});

                                        const op = {target: t,action:null};

                                        dispatch({"type":"setOperation", "operation": op});

                                        dispatch({"type":"setMetadata", "metadata": metadata});

                                    }
                                } >{t}</button>


                            </td>
                        </tr>


                        )
                    )
                }

            </tbody>
        </table>

        </>
    );
};

